import { configWithUserToken } from "./config";
import { IEmailPreference, IUpdateEmailPreference } from "../models/IEmailPreference";

export const getEmailPreferences = () => {
  return configWithUserToken.get<IEmailPreference>("EmailPreference");
};

export const updateEmailPreferences = (data: IUpdateEmailPreference) => {
  return configWithUserToken.put<IEmailPreference>("EmailPreference", data);
};
